export const REGISTRATION_STATUS_INDEX: Record<string, number> = {
  notregistered: 0,
  register: 1,
  generalinfo: 2,
  uploaddocuments: 3,
  vendorinfo: 4,
  bankinfo: 5,
  waitingforadminapprove: 6,
  kycidentityinfo: 7,
  kycfacerecognition: 8,
  kycsendotp: 9,
  signcontract: 10,
  finish: 11
};
